module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="product_search_top">\n  <p class="product_search_instructions">\n    ' +
__e( I18n.t('uploader.product_tagging_search.select_product') ) +
'\n  </p>\n  <div class="product_search_area">\n    <input type="text" class="product_search_field" name="product_search_field"\n           id="product_search_field" placeholder="' +
((__t = ( I18n.t('uploader.product_tagging_search.search_product') )) == null ? '' : __t) +
'"\n           aria-label="' +
((__t = ( I18n.t('uploader.product_tagging_search.search_product') )) == null ? '' : __t) +
'"\n           value="' +
((__t = ( search_term )) == null ? '' : __t) +
'" />\n    <div class="product_search_clear_area">\n      <button type="button" class="product_search_clear">\n        <div class="product_search_clear_rect1"></div>\n        <div class="product_search_clear_rect2"></div>\n      </button>\n    </div>\n  </div>\n  <div class="product_search_results_container">\n  </div>\n</div>\n\n<div class="product_search_done_tagging_button_container">\n  <button class="product_search_done_tagging_button">' +
((__t = ( I18n.t('uploader.product_tagging_search.completion_button') )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
}